module.exports = "/images/mv_bg_02.png?6cb1830123b90d391de4a8b88cc3de24";